<div
  *ngIf="isLoading"
  class="row center">
  <div class="col">
    <app-loading-icon
      class="u-color--light"
      size="2x"></app-loading-icon>
  </div>
</div>
<div
  [hidden]="dataSource.data?.length"
  class="row center">
  <div class="col">
    <h2>{{ "fieldservice.notoolsfound" | translate }}</h2>
  </div>
</div>
<div
  [hidden]="!dataSource.data?.length"
  class="col">
  <div class="o-grid u-pb--medium">
    <div class="o-grid__item col-12 col-md-3 col-sm-5 u-p-bottom-only">
      <form class="c-search-form--full">
        <div class="c-input-group">
          <input
            type="text"
            name="search"
            id="input-search"
            [(ngModel)]="dataSource.filter"
            class="c-input c-input--beta"
            placeholder="{{ localizationConstants.QUICK_GRID_FILTER_SEARCH | translate }}"
            required />
          <input
            *ngIf="dataSource.filter"
            id="contract-items-search-clear"
            (click)="dataSource.filter = ''"
            class="c-button c-button--search c-close-search c-button--search--sm"
            value="Clear" />
          <input
            *ngIf="!dataSource.filter"
            id="contract-items-search"
            type="submit"
            class="c-button c-button--search c-button--search--sm"
            value="Search" />
        </div>
      </form>
    </div>
  </div>
  <div
    id="fieldservice-tools"
    class="col bg-white u-shadow u-scroll--horizontal">
    <div
      id="fieldservice-tools-table"
      class="col">
      <table
        mat-table
        matSort
        [dataSource]="dataSource"
        class="c-table">
        <ng-container
          *ngFor="let col of columns"
          [matColumnDef]="col.key">
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef>
            {{ col.title | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="c-clickable"
            [routerLink]="[
              routeNameConstants.TOOLS_DETAILS_BASE,
              element.companyId,
              element.serialNumber,
            ]">
            {{ element[col.key] }}
          </td></ng-container
        >

        <tr
          mat-header-row
          *matHeaderRowDef="columnKeys"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: columnKeys"
          class="c-table__row"></tr>
      </table>
    </div>
  </div>
  <div class="c-pagination--desktop">
    <div
      [hidden]="!dataSource.data?.length"
      class="col-12">
      <mat-paginator
        [showFirstLastButtons]="true"
        [pageSize]="pageSize"
        [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
    </div>
  </div>
</div>
